<template>
  <v-dialog
    ref="dialog"
    close-on-content-click
    transition="scale-transition"
    offset-y
    max-width="320px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-flex
        class="text-xs-right"
        xs12
        style="cursor: pointer;"
        v-on="on"
      >
        <DeliveryToolTip :delivery="delivery">
          <v-text-field
            label="配送指定日"
            :value="displayDate"
            readonly
            class="input"
          />
        </DeliveryToolTip>
      </v-flex>
    </template>
    <v-date-picker
      :value="delivery.ISOdate"
      :min="minDateValue"
      :max="(new Date().getFullYear()+2).toString()"
      full-width
      no-title
      locale="ja-JP"
      :day-format="dayFormat"
      prev-icon="mdi-arrow-left-drop-circle"
      next-icon="mdi-arrow-right-drop-circle"
      @input="update"
    >
      <v-btn
        v-if="delivery.ISOdate"
        color="red darken-1"
        flat
        outline
        @click="clearBtnHandler"
      >
        クリアする
      </v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
import { epoch2fullDate } from '@/utils/time.js'
import { DeliveryToolTip } from '@/views/list/components/DeliveryTable/index'

export default {
  name: 'DatePicker',
  components: {
    DeliveryToolTip
  },
  props: {
    delivery: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    minDateValue () {
      return epoch2fullDate(Date.now() / 1000, '-')
    },
    displayDate () {
      return this.delivery.ISOdate
        ? this.delivery.ISOdate.split('-').join('/')
        : ''
    }
  },
  methods: {
    update (e) {
      this.$emit('input', e)
      this.$refs.dialog.save()
      this.$emit('toggleDialog')
    },
    dayFormat (value) {
      return parseInt(value.substring('YYYY-MM-'.length), 10)
    },
    clearBtnHandler () {
      this.$refs.dialog.save()
      this.$emit('set-clear-date-dialog')
    }
  }
}
</script>
<style lang="scss" scoped>
.v-picker {
  padding: 12px 12px 0;
  border-radius: 10px;

&.v-picker--date.theme--light /deep/ {
  .v-date-picker-header .v-btn--icon .v-btn__content {
    color: rgba(0, 0, 0, .54);
  }
  .v-date-picker-table{
  height: auto;
  padding-bottom: 10px;

  &--date, &--month  {
    .v-btn {
      width: 41px;
      height: 41px;
      padding-left: 0;
      padding-right: 0;
      &:not(.v-btn--disabled) {
        .v-btn__content {
          color: black;
        }
      }
    }
}
    }
  }
}
.input {
  pointer-events: none;

  & /deep/ input {
    font-size: 1rem !important;
  }
}
/deep/.v-picker__actions.v-card__actions{
  display: flex;
  justify-content: flex-end;
}
 </style>
